import React, { useState } from 'react';

import { VisibilityContext } from 'react-horizontal-scrolling-menu';

import { IoIosArrowForward } from 'react-icons/io';

import Arrow from '..';

const ArrowRight: React.FC = () => {
  const {
    isLastItemVisible,
    scrollNext,
    visibleItemsWithoutSeparators,
  } = React.useContext(VisibilityContext);

  const [disabled, setDisabled] = useState(
    !visibleItemsWithoutSeparators.length && isLastItemVisible,
  );
  React.useEffect(() => {
    if (visibleItemsWithoutSeparators.length) {
      setDisabled(isLastItemVisible);
    }
  }, [isLastItemVisible, visibleItemsWithoutSeparators]);

  return (
    <Arrow disabled={disabled} onClick={() => scrollNext()}>
      <IoIosArrowForward size={40} />
    </Arrow>
  );
};

export default ArrowRight;
